module.exports = __webpack_public_path__ + "static/media/cross.e5d880d8.svg";